import {AbstractMulti as SuperAbstractMulti} from "../../../clone/dialog/AbstractMulti";
import {IMessage} from "../../../index";
import {global} from "../../../appContext";
import PromiseRequest from "../../../req/PromiseRequest";
import {ObjectTypeId} from "../../../constants";

export {Step} from "../../../clone/dialog/AbstractMulti";

export abstract class AbstractMulti extends SuperAbstractMulti<IMessage> {
    protected req_fetch: PromiseRequest = global.getPromiseRequest('searchmessage')
    protected objectTypeId: ObjectTypeId = ObjectTypeId.Message
}